import { BrowserRouter, Routes, Route } from 'react-router'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { Toaster } from 'sonner'
import { NotFoundPage } from '@/shared/components/not-found-page'
import UploadPage from './pages/upload-page'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: true,
      retry: (failureCount, error: unknown) => {
        const status = (error as { response?: { status?: number } })?.response?.status
        if (status === 404 || status === 410) return false
        return failureCount < 2
      },
    },
  },
})

if (import.meta.env.DEV) {
  ;(window as unknown as { __irisQueryClient: QueryClient }).__irisQueryClient = queryClient
}

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <Routes>
          <Route path="/u/:token" element={<UploadPage />} />
          <Route path="/upload/:token" element={<UploadPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" />
    </QueryClientProvider>
  )
}
// ci-incremental-proof B (revert/close)
